import fetch from "lib/fetch"
import {
  deferUntilPermitted,
  META_PIXEL_DIDOMI_VENDOR_ID,
} from "@theconversation/shared-libraries/Didomi"

/*
  This is the "lightweight" implementation of the meta pixel tracker. Although facebook recommends
  using the "full" tracker (which involves downloading and executing third party scripts), this
  lightweight implementation meets all our current needs, is less invasive, and has a smaller footprint.

  https://developers.facebook.com/docs/meta-pixel/advanced#installing-the-pixel-using-an-img-tag
*/
/** @internal Knip: exported for tests */
export const createEventEmitter = (pixelId) => ({
  emit: (eventName, parameters = {}) => {
    const customParameters = Object.keys(parameters).reduce(
      (s, key) => s + `&cd[${key}]=${encodeURIComponent(parameters[key])}`,
      "",
    )
    fetch(`https://www.facebook.com/tr?id=${pixelId}&ev=${eventName}${customParameters}`)
  },
})

export default function emitMetaPixelEventsForContentRead(contentId, contentTitle, metaPixelId) {
  if (!metaPixelId || !contentId) return

  // Deferring until Didomi tells us whether we have consent for the "facebook" vendor means we
  // find out at the point these events would actually fire, rather than relying on whatever
  // consent status was in effect back when this function was first called.
  deferUntilPermitted({
    vendorId: META_PIXEL_DIDOMI_VENDOR_ID,
    callback: () => {
      const emitter = createEventEmitter(metaPixelId)

      // We're only ever called from content.js (Content#show), so content_type is hardcoded to
      // "content" here rather than accepted as a parameter.
      emitter.emit("ViewContent", {
        content_name: contentTitle,
        content_type: "content",
        content_ids: contentId,
      })

      // After 15 seconds we emit a `AddToCard` event, this was changed from
      // the previous `TimeOnPage` and `Lead` event, as Benedictus (the ad agency) was having
      // trouble integrating it into their system (despite originally asking for it).
      setTimeout(() => emitter.emit("AddToCart"), 15000)
    },
  })
}
